import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_URL;

axios.interceptors.request.use(
  async (config) => {
    document.body.classList.add("loading-indicator-api");
    config.headers['Content-type'] = "application/json; charset=UTF-8"
    config.headers["X-Client-Id"] = process.env.REACT_APP_CLIENT_ID;
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  function (response) {
    document.body.classList.remove("loading-indicator-api");
    return response;
  },
  async function (error) {
    document.body.classList.remove("loading-indicator-api");
    return Promise.reject(error);
  }
);



export async function getApi(path, config = {}) {
  try {
    const result = await axios.get(path, config);
    return Promise.resolve(result.data)
  } catch (err) {
    console.error(err)
    return Promise.reject(err.response.data.error);
  }
}
export async function postApi(path, body, config = {}) {
  try {
    const result = await axios.post(path, body, config);
    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err.response.data.error);
  }
}

export async function postApiCustom(path, body, config = {}) {
  try {
    const result = await axios.post(path, body, config);   
    return Promise.resolve(result)
  } catch (err) {
    return Promise.reject(err);
  }
}

export default axios;
